function Logo({ className = '' }) {
  return (
    <svg
      className={`block w-full h-full ${className}`}
      viewBox="0 0 360 96"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      focusable="false"
      aria-label="MH-BETON"
    >
      <rect
        x="4"
        y="4"
        width="352"
        height="88"
        rx="6"
        fill="none"
        stroke="rgba(50, 185, 232, 0.96)"
        strokeWidth="2"
        strokeLinecap="square"
        style={{ filter: 'drop-shadow(0 0 5px rgba(50, 185, 232, 0.42))' }}
      />
      <text
        x="180"
        y="56"
        textAnchor="middle"
        textLength="284"
        lengthAdjust="spacingAndGlyphs"
        fill="#32b9e8"
        fontSize="38"
        fontWeight="800"
        style={{ filter: 'drop-shadow(0 4px 10px rgba(0, 0, 0, 0.34))' }}
      >
        MH-BETON
      </text>
      <text
        x="180"
        y="80"
        textAnchor="middle"
        textLength="276"
        lengthAdjust="spacingAndGlyphs"
        fill="rgba(242, 251, 255, 0.82)"
        fontSize="10.6"
        fontWeight="600"
        style={{ filter: 'drop-shadow(0 2px 6px rgba(0, 0, 0, 0.3))' }}
      >
        Für jeden Bau das richtige Fundament
      </text>
    </svg>
  );
}

export default Logo;
